import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useLocation } from 'react-router'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import classes from './ConfigTableData.module.scss'
import { TAB_LIST } from './constant'
import {
  changeActiveTab,
  changeIsShowCommonSize,
  selectActiveTab,
} from './store/slice'
import { financialStatementsTable } from './store/thunk'
import { BalanceSheet } from './tabs/balanceSheet/BalanceSheet'
import { CashFlowStatement } from './tabs/cashFlowStatement/CashFlowStatement'
import { IncomeStatement } from './tabs/incomeStatement/IncomeStatement'

export const tabs = [
  {
    ...TAB_LIST.BALANCE_SHEET,
    children: <BalanceSheet />,
  },
  {
    ...TAB_LIST.INCOME_STATEMENT,
    children: <IncomeStatement />,
  },
  {
    ...TAB_LIST.CASH_FLOW_STATEMENT,
    children: <CashFlowStatement />,
  },
]

export const ConfigTableData = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const activeTab = useSelector(selectActiveTab)

  const organizationIdParams = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  }).organizationId

  const onClickTab = (item) => {
    if (item.key !== activeTab) {
      dispatch(changeActiveTab(item.key))
    }
  }

  const resetFilter = () => {
    dispatch(changeIsShowCommonSize(true))
    dispatch(
      financialStatementsTable({
        organizationId: organizationIdParams,
      }),
    )
  }

  const renderContent = () => {
    if (activeTab) {
      return tabs.find((item) => item.key === activeTab)?.children
    }
  }

  return (
    <Element className={classes.container}>
      <Element className={classes.tabContainer}>
        <div className={classes.tabs}>
          {tabs.map((tab) => (
            <Element
              key={tab.key}
              className={classes.tabItem}
              style={
                tab.key === activeTab
                  ? {
                      color: '#ffffff',
                      backgroundColor: '#2C73E8',
                      fontSize: 12,
                    }
                  : {
                      color: '#191D25',
                      backgroundColor: '#F3F3F3',
                      fontSize: 12,
                    }
              }
              onClick={() => onClickTab(tab)}
            >
              <Translate value={tab.label} />
            </Element>
          ))}
        </div>
        <Element
          style={{ color: '#2c73e8', backgroundColor: '#c8e3ff' }}
          className={classes.resetFilter}
          onClick={resetFilter}
        >
          <Icon
            className="icon-reset2"
            style={{ fontSize: 12, marginRight: 4 }}
          />
          <Translate value="financialStatement.RESET_FILTER" />
        </Element>
      </Element>
      <Element className="fstItalic" style={{ fontSize: 12 }}>
        <Translate value="financialStatement.TEXT_NOTE" />
      </Element>
      <Element className={classes.tabContent}>{renderContent()}</Element>
    </Element>
  )
}
